// extracted by mini-css-extract-plugin
module.exports = {"applePayButton":"AdyenApplePay_applePayButton__5w_Xr"};